import { render, staticRenderFns } from "./TandemFiltersComponent.vue?vue&type=template&id=8fe594dc&scoped=true&lang=pug"
import script from "./TandemFiltersComponent.vue?vue&type=script&lang=ts"
export * from "./TandemFiltersComponent.vue?vue&type=script&lang=ts"
import style0 from "./TandemFiltersComponent.vue?vue&type=style&index=0&id=8fe594dc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe594dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fe594dc')) {
      api.createRecord('8fe594dc', component.options)
    } else {
      api.reload('8fe594dc', component.options)
    }
    module.hot.accept("./TandemFiltersComponent.vue?vue&type=template&id=8fe594dc&scoped=true&lang=pug", function () {
      api.rerender('8fe594dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/search/TandemSearch/TandemFiltersComponent.vue"
export default component.exports